import styled from 'styled-components';

export const ParagraphStyles = styled.p`
  margin: 0;
`;
